import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { anyU } from 'src/app/models/anyU';
import { environment } from 'src/environments/environment';
import { weblogU } from 'src/app/models/weblogU';

import { Router } from '@angular/router'; // برای مسیریابی به صفحه جزئیات
declare var bootstrap: any;


@Component({
  selector: 'app-weblog',
  templateUrl: './weblog.component.html',
  styleUrls: ['./weblog.component.css']
})
export class WeblogComponent {

 baseUrl = environment.apiBaseUrl;
  @ViewChild('userModal') userModal: ElementRef | undefined;

  allPosts: weblogU[] = []; // لیست کامل همه پست‌ها
  displayPosts: weblogU[] = []; // لیستی که در تمپلیت نمایش داده می‌شود (شامل خلاصه توضیحات)

  anyList: any[] = [];
  anyObj: any ={
      "id":0,
      "title":"",
      "description":"",
      "wich_kind":"",
  }
  http = inject(HttpClient);
  private router = inject(Router); // Router را تزریق می‌کنیم

   ngOnInit(): void {
    this.getAllpost()
  }

  // constructor(private userService: Service) {}

  openModal(): void {
  // console.log("openModal triggered");
  if (this.userModal) {
    const modal = new bootstrap.Modal(this.userModal.nativeElement);
    modal.show();
  } else {
    // console.warn("userModal is undefined!");
  }
}


closeModal(): void {
  if (this.userModal) {
    const modal = bootstrap.Modal.getInstance(this.userModal.nativeElement);
    if (modal) modal.hide();
  }
}

 // تابع getShortDescription (اگر هنوز اضافه نکرده‌اید)
      getShortDescription(description: string): string {
        if (description.length > 100) {
          return description.substring(0, 100) + '...';
        }
        return description;
      }

  getAllpost(): void {

    this.http.get<weblogU[]>(`${this.baseUrl}/weblog`).subscribe((res) => {
       this.allPosts = res;
      // console.log(this.anyList); // چاپ داده‌ها برای بررسی

       this.displayPosts = res.map(post => ({
        ...post,
        description: this.getShortDescription(post.description) // فرض می‌کنیم فیلد description دارید
      }));
    });
  }

// تابع کلیک برای رفتن به جزئیات پست
  goToPostDetail(id: number): void { // اینجا id از نوع number تعریف شده
    console.log(`Navigating to detail for post ID: ${id}`);
    // اگر نیاز باشد id را به رشته تبدیل کنید، اینجا انجام دهید:
    this.router.navigate(['/weblog/detail', id.toString()]);
    // یا اگر مسیرتان را برای پذیرش عدد آماده کرده‌اید، مستقیماً id را بفرستید
    // this.router.navigate(['/weblog/detail', id]);
  }



  onSave1(): void {
    // console.log("Sending anyObj:", this.anyObj);
    this.http.post<anyU>(`${this.baseUrl}/weblog`, this.anyObj).subscribe({
      next: (res) => {
        this.getAllpost();
        this.closeModal();
      },
      error: (err) => {
        console.error("Error details:", err);
      }
  });
  }

  onSave(): void {
  if (this.anyObj.id === 0) {
    // افزودن
    const newUser = { ...this.anyObj };
    delete newUser.id; // ← ID را حذف کن که نره به سرور

    this.http.post<weblogU>(`${this.baseUrl}/weblog`, newUser).subscribe((res) => {
      this.getAllpost();
      this.closeModal();
    });
  } else {
    // ویرایش
    // this.http.put<anyU>(`${this.baseUrl}/mythings/${this.anyObj.id}`, this.anyObj).subscribe((res) => {

    this.http.post<weblogU>(`${this.baseUrl}/weblog/update`, this.anyObj).subscribe((res) => {
      this.getAllpost();
      this.closeModal();
    });
  }
}

 openEditModal(postId: number): void {
      this.http.get<weblogU>(`${this.baseUrl}/weblog/${postId}`).subscribe({ // فرض می‌کنیم API برای دریافت یک پست با ID از این مسیر استفاده می‌کند
        next: (fullPostData) => {
          this.anyObj = { ...fullPostData }; // حالا anyObj با داده‌های کامل پست پر می‌شود
          this.openModal(); // باز کردن مودال
        },
        error: (err) => {
          console.error("خطا در دریافت اطلاعات پست برای ویرایش:", err);
          // می‌توانید یک پیام خطا به کاربر نمایش دهید
        }
      });
    }
    
  // حذف کاربر
  delete(Id: number): void {
    if (confirm("آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟")) {
      // this.http.delete(`${this.baseUrl}/mythings/${Id}`).subscribe(() => {
        // this.http.post(`${this.baseUrl}/mythings/delete`, Id).subscribe(() => {
        this.http.post(`${this.baseUrl}/weblog/delete/${Id}`, null).subscribe(() => {

        this.getAllpost(); // بعد از حذف، لیست کاربران را مجدد بگیر
      });
    }
  }

  fixUrl(url: string): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return 'http://' + url;
}


}


